import React, { useState, useEffect, createRef } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import facilityService from "../services/facility-service";
import userService from "../services/users-service";
import cogoToast from "cogo-toast";
import { selectUsers } from "../state/reducers/userSlice";
import auth from "../services/auth";
import { Modal } from "react-responsive-modal";
import { updateUserState } from "../state/reducers/userSlice";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { Multiselect } from "multiselect-react-dropdown";

const CreateUser = ({ history }) => {
  let { user } = useSelector(selectUsers);
  const { userId } = useParams();
  const [chgepwdOpen, setChgepwdOpen] = useState(false);
  const onClosePwdModal = () => setChgepwdOpen(false);
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, errors, reset, setValue, getValues } =
    useForm({});
  const [userType, setUserType] = useState("");
  const [userRole, setUserRole] = useState("");
  const [facilityDisable, setFacilityDisable] = useState();
  const [userdetails, setUserDetails] = useState();
  const [facilitySelected, setfacilitySelected] = useState();

  const [payorListSelected, setPayorListSelected] = useState();
  const [grpListSelected, setGrpListSelected] = useState();

  const [deptSelected, setdeptSelected] = useState();
  const [facilityList, setFacilitiesList] = useState();

  const [facSelected, setFacSelected] = useState([]);
  const [payorSelected, setPayorSelected] = useState([]);
  const [grpsSelected, setGrpsSelected] = useState([]);

  const [facChange, setfacChange] = useState(false);
  const [payorChange, setPayorChange] = useState(false);
  const [grpCodeChange, setGrpCodeChange] = useState(false);

  const [parentsList, setParentList] = useState([]);

  const [groupCodeList, setGroupList] = useState([]);

  const [cipsUserList, setCipsUserList] = useState([]);
  const [cipsUserSelected, setCipsUserSelected] = useState([]);

  const dispatch = useDispatch();
  const multiselectRef = createRef();
  const multiselectRef1 = createRef();
  const multiselectRef2 = createRef();
  const multiselectRefCips = createRef();
  //getFacilities
  useEffect(() => {
    getUserDetails();
    if (
      user?.userRole === "FACILITY_ADMIN" ||
      user?.userRole === "DEPARTMENT_ADMIN"
    ) {
      setFacilityDisable("disabled");
    }
    if (
      user?.userRole === "DEPARTMENT_ADMIN" ||
      user?.userRole === "PORTAL_ADMIN"
    ) {
      setValue("department", user?.department);
      setdeptSelected(user?.department);
      if (user?.userRole === "DEPARTMENT_ADMIN") {
        setValue("deptid", user?.department);
      }
    }
  }, [user]);

  const getCipsUsers = async (search) => {
    if (search.trim().length >= 3) {
      try {
        let response = await userService.getCipsUsers({ search: search });
        setCipsUserList([]);
        setCipsUserList(response);
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error retrieving cips users. Please contact administrator.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
    }
  };
  const getUserDetails = async () => {
    if (userId) {
      try {
        if (user?.userId === parseInt(userId)) {
          setUserDetails(user);
          setUserType(user.userType);
          setUserRole(user.userRole);
          setUserDetails(user);
          setValue("userType", user.userType);
          setValue("userRole", user.userRole);
          setValue("department", user?.department);
          setValue("facility", user?.facility);
          setValue("uRole", user?.userRole);
          setValue("fid", user?.facility ? parseInt(user?.facility) : 0);
          setValue("deptid", user?.department);
          setValue("uType", user?.userType);
          setdeptSelected(user?.department);
          let cipsUser = await userService.getCipsUsers({ id: user?.cipsId });
          setCipsUserList(cipsUser);
          setCipsUserSelected(cipsUser);
          //setfacilitySelected(user?.facility);
        } else {
          setLoading(true);
          let resp = await userService.getUserById(userId);
          let userFacilities = await facilityService.getFacilityById(userId);
          if (userFacilities) {
            setfacilitySelected(userFacilities);
          }
          let userpayorList = await userService.getPayorById(userId);
          if (userpayorList.length > 0) {
            let defaultSelectedPayor = userpayorList.map((a) => a.payor);
            setPayorListSelected(defaultSelectedPayor);
            try {
              setLoading(true);
              let totalGroupList = await userService.getGroupCodes(
                defaultSelectedPayor.join(",")
              );
              setLoading(false);
              setGroupList(totalGroupList);
            } catch (e) {
              const { hide } = cogoToast.error(
                "Error retrieving group codes. Please contact administrator.",
                {
                  hideAfter: 15,
                  onClick: () => {
                    hide();
                  },
                }
              );
              setLoading(false);
            }
          }
          let userGrpList = await userService.getGrpsById(userId);
          setGrpListSelected(userGrpList);
          setLoading(false);
          if (resp) {
            setUserType(resp.userType);
            setUserRole(resp.userRole);
            setUserDetails(resp);
            setValue("payor", resp?.payor);
            setValue("userType", resp.userType);
            setValue("userRole", resp.userRole);
            setValue("department", resp?.department);
            setValue("uRole", resp?.userRole);
            setValue("fid", resp?.facility);
            setValue("deptid", resp?.department);
            setValue("uType", resp?.userType);
            setdeptSelected(resp?.department);
            //setfacilitySelected(resp?.facility);
            let cipsUser = await userService.getCipsUsers({ id: resp?.cipsId });
            setCipsUserList(cipsUser);
            setCipsUserSelected(cipsUser);
          }
        }
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error retrieving user details. Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        return false;
      }
    }
    try {
      setLoading(true);
      let totalFacList = await facilityService.getFacilities();
      if (user?.userRole === "FACILITY_ADMIN") {
        var finalArry = [];
        let resp = await userService.getPayorById();
        if (resp) {
          resp.forEach((element) => {
            return finalArry.push(element.payor);
          });
          setParentList(finalArry);
        }
      } else {
        let resp = await userService.getPayors();
        if (resp) {
          setParentList(resp);
        }
      }
      setLoading(false);
      setFacilitiesList(totalFacList);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error retrieving user details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  function handleChangeDept(deptValue) {
    setValue("deptid", deptValue);
  }
  function changeUserType(value) {
    setValue("uType", value);
    setUserType(value);
    setUserRole();
    setValue("userRole", "");
    if (value === "EXTERNAL" && facilitySelected) {
      setValue("fid", facilitySelected[0]?.id);
    }
  }
  function changeUserRole(value) {
    setValue("uRole", value);
    const selectedUtype = getValues("uType");
    setUserRole(value);
    if (selectedUtype === "EXTERNAL" && facilitySelected) {
      if (facChange && facSelected) {
        if (facSelected[0]) {
          setValue("fid", facSelected[0]);
        }
      } else {
        setValue("fid", facilitySelected[0]?.id);
      }
    }
  }

  const onSubmit = async (data) => {
    let new_user = {};
    if (userId) {
      new_user = {
        firstName: data.first_name,
        lastName: data.last_name,
        email: data.email,
        phone: data.phone_number,
        userId: userId,
        userType: data.uType,
        userRole: data.uRole,
      };

      if (user?.userId === parseInt(userId)) {
        let stateUpdate = {
          firstName: data.first_name,
          lastName: data.last_name,
          email: data.email,
          phone: data.phone_number,
        };
        new_user.currentUser = true;
        dispatch(updateUserState(stateUpdate));
      } else {
        new_user.currentUser = false;
      }
    } else {
      new_user = {
        userName: data.email,
        userType: data.uType,
        userRole: data.uRole,
        firstName: data.first_name,
        lastName: data.last_name,
        email: data.email,
        phone: data.phone_number,
        blocked: false,
      };
    }
    if (cipsUserSelected.length > 0) {
      new_user.cipsId = cipsUserSelected[0].id;
    } else {
      new_user.cipsId = 0;
    }
    if (data.uRole === "PORTAL_ADMIN") {
      new_user.facility = 0;
      new_user.department = "NONE";
    } else if (
      data.uRole === "DEPARTMENT_ADMIN" ||
      data.uRole === "DEPARTMENT_USER"
    ) {
      new_user.department = data.deptid;
      new_user.facility = 0;
    } else if (
      data.uRole === "FACILITY_ADMIN" ||
      data.uRole === "FACILITY_USER" ||
      data.uRole === "EMAR_USER"
    ) {
      new_user.facility = data.fid;
      new_user.department = "NONE";
    }
    if (data.uRole === "FACILITY_ADMIN" || data.uRole === "FACILITY_USER" || data.uRole === "FEMAR_USER") {
      // eslint-disable-next-line eqeqeq
      if (getValues("fid") == "" && getValues("fid") == 0) {
        const { hide } = cogoToast.error("Please Select Atleast One Facility", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
        return false;
      }
    }
    try {
      let resp = {};
      let msg = "";
      if (data?.payor) {
        new_user.payor = data.payor;
      }
      if (userId) {
        resp = await userService.updateUser(new_user);
        msg = "The user updated successfully";
      } else {
        resp = await auth.createUser(new_user);
        msg = "The new user created successfully";
      }
      if (resp) {
        if (facChange) {
          let insertFacilities = {
            facilities: facSelected,
          };
          if (userId) {
            insertFacilities.userId = userId;
          } else {
            insertFacilities.userId = resp.userId;
          }
          await userService.updateFacility(insertFacilities);
          reset({});
          setUserRole("");
          setUserType("");
        }
        if (payorChange) {
          let insertPayorList = {
            payors: payorSelected,
          };
          if (userId) {
            insertPayorList.userId = userId;
          } else {
            insertPayorList.userId = resp.userId;
          }
          await userService.updatePayors(insertPayorList);
          reset({});
          setUserRole("");
          setUserType("");
        }
        if (grpCodeChange) {
          let insertgrpCodes = {
            groups: grpsSelected,
          };
          if (userId) {
            insertgrpCodes.userId = userId;
          } else {
            insertgrpCodes.userId = resp.userId;
          }
          await userService.updateGrpCodes(insertgrpCodes);
          reset({});
          setUserRole("");
          setUserType("");
        }
        const { hide } = cogoToast.success(msg, {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
        if (
          user?.userRole === "FACILITY_USER" ||
          user?.userRole === "EMAR_USER" ||
          user?.userRole === "DEPARTMENT_USER"
        ) {
          await history.push("/dashboard");
        } else {
          await history.push("/users");
        }
      } else {
        const { hide } = cogoToast.error(
          "Error saving user details. Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error saving user details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const changePwdSubmit = async (data) => {
    let passwordData = {
      currentPassword: data.currentPaswd,
      newPassword: data.newPaswd,
    };
    setLoading(true);
    let resp = await userService.changePassword(passwordData);
    setLoading(false);

    if (resp) {
      setChgepwdOpen(false);
      if (resp.code === 200 || resp.code === 204) {
        const { hide } = cogoToast.success("Password Changed Successfully", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
      } else {
        const { hide } = cogoToast.error(resp.msg, {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
      }
    } else {
      const { hide } = cogoToast.error(resp.msg, {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
    }
  };
  function facSelect() {
    let currentValue = multiselectRef.current.getSelectedItems();
    let final_array = currentValue.map((p) => p.id);
    setFacSelected(final_array);
    setValue("fid", final_array[0]);
    setfacChange(true);
  }
  async function payorSelect() {
    let currentPayors = multiselectRef1.current.getSelectedItems();
    setPayorSelected(currentPayors);
    setGrpListSelected([]);
    setPayorChange(true);
    if (currentPayors.length > 0) {
      try {
        setLoading(true);
        let totalGroupList = [];
        if (user?.userRole === "FACILITY_ADMIN") {
          totalGroupList = await userService.getGrpsById();
        } else {
          totalGroupList = await userService.getGroupCodes(
            currentPayors.join(",")
          );
        }
        setLoading(false);
        setGroupList(totalGroupList);
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error retrieving details. Please contact administrator.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        setLoading(false);
      }
    } else {
      setGroupList([]);
    }
  }
  function grpsSelect() {
    let currentGrpValue = multiselectRef2.current.getSelectedItems();
    setGrpsSelected(currentGrpValue);
    setGrpCodeChange(true);
  }
  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <CipHeader />
      <div className="bg-white w-1/2 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3 w-full">
          <div className="w-full text-darkclr font-semibold leading-10 ">
            <span className="text-xl">
              {userdetails ? "EDIT USER" : "CREATE NEW USER"}
            </span>
          </div>
        </div>
        <div className="px-12 py-5">
          <form onSubmit={handleSubmit(onSubmit)}>
            <ul className="text-left">
              <li className="inline-block text-sm leading-8 w-full text-center">
                <img
                  src="img/administration2.svg"
                  alt=""
                  className="inline-block w-12"
                />
              </li>

              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  First Name
                </label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>

                <input
                  id="first_name"
                  name="first_name"
                  type="text"
                  placeholder="First Name"
                  autoComplete="username"
                  ref={register({
                    required: "You must specify first name",
                  })}
                  defaultValue={userdetails?.firstName || ""}
                  className={` ${
                    errors.first_name ? "border-red-400" : ""
                  } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                />

                {errors.first_name && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred">
                    {errors.first_name?.message}
                  </p>
                )}
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Last Name
                </label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                <input
                  id="last_name"
                  name="last_name"
                  type="text"
                  placeholder="Last Name"
                  autoComplete="lastname"
                  defaultValue={userdetails?.lastName || ""}
                  ref={register({
                    required: "You must specify last name",
                  })}
                  className={` ${
                    errors.last_name ? "border-red-400" : ""
                  } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                />

                {errors.last_name && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred">
                    {errors.last_name?.message}
                  </p>
                )}
              </li>
              <>
                {userdetails ? (
                  <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                    <label className="text-labelclr font-semibold text-sm tracking-wider">
                      Username
                    </label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      readOnly={true}
                      defaultValue={userdetails?.userName || ""}
                      className={` ${
                        errors.email ? "border-red-400" : ""
                      } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                    />
                  </li>
                ) : (
                  ""
                )}
              </>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Email Id
                </label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                <input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Email"
                  autoComplete="email"
                  defaultValue={userdetails?.email || ""}
                  ref={register({
                    required: "You must specify email",
                  })}
                  className={` ${
                    errors.email ? "border-red-400" : ""
                  } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                />

                {errors.email && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred">
                    {errors.email?.message}
                  </p>
                )}
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Phone Number
                </label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                <input
                  id="phone_number"
                  name="phone_number"
                  type="number"
                  placeholder="Phone Number"
                  autoComplete="phone"
                  defaultValue={userdetails?.phone || ""}
                  ref={register({
                    required: "You must specify Phone Number",
                  })}
                  className={` ${
                    errors.phone_number ? "border-red-400" : ""
                  } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                />

                {errors.phone_number && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred">
                    {errors.phone_number?.message}
                  </p>
                )}
              </li>
            {user?.userRole === 'PORTAL_ADMIN' && <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  CIPS User
                </label>
                {cipsUserList ? (
                  <Multiselect
                    name="cipsUserList"
                    displayValue="name"
                    selectedValues={cipsUserSelected}
                    options={cipsUserList}
                    ref={multiselectRefCips}
                    avoidHighlightFirstOption={true}
                    selectionLimit={1}
                    hidePlaceholder={true}
                    caseSensitiveSearch={true}
                    onSelect={(selectedList, selectedItem) => {
                      setCipsUserSelected([selectedItem]);
                    }}
                    onSearch={(value) => {
                      getCipsUsers(value);
                    }}
                    onRemove={() => {
                      setCipsUserSelected([]);
                    }}
                  />
                ) : (
                  ""
                )}
              </li>}
              <>
                {user?.userId === userdetails?.userId ? (
                  ""
                ) : (
                  <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                    <label className="text-labelclr font-semibold text-sm tracking-wider">
                      User Type
                    </label>
                    <span className="text-xs md:text-sm text-hlred ml-1">
                      *
                    </span>
                    <p>
                      {user?.userRole === "PORTAL_ADMIN" ||
                      user?.userRole === "DEPARTMENT_ADMIN" ? (
                        <span className="hover:bg-header_bg px-5 py-2 rounded-md">
                          <input
                            name="userType"
                            type="radio"
                            value="INTERNAL"
                            onChange={(e) => {
                              changeUserType(e.target.value);
                            }}
                            ref={register({
                              required: "You must specify user type",
                            })}
                            className="mx-2"
                          />
                          <label className="text-labelclr font-semibold text-sm tracking-wider">
                            INTERNAL
                          </label>
                        </span>
                      ) : (
                        ""
                      )}
                      {user?.userRole === "PORTAL_ADMIN" ||
                      user?.userRole === "FACILITY_ADMIN" ? (
                        <span className="hover:bg-header_bg px-5 py-2 rounded-md">
                          <input
                            name="userType"
                            type="radio"
                            value="EXTERNAL"
                            onChange={(e) => {
                              changeUserType(e.target.value);
                            }}
                            ref={register({
                              required: "You must specify user type",
                            })}
                            className="mx-2"
                          />
                          <label className="text-labelclr font-semibold text-sm tracking-wider">
                            EXTERNAL
                          </label>
                        </span>
                      ) : (
                        ""
                      )}
                    </p>
                  </li>
                )}
              </>
              {errors.userType && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  {errors.userType?.message}
                </p>
              )}
              <>
                {user?.userId === userdetails?.userId ? (
                  ""
                ) : (
                  <li
                    className={`inline-block text-xs leading-6 text-menu_txt w-full mb-3 ${
                      userType === "EXTERNAL" ? "show" : "hidden"
                    }`}
                  >
                    <label className="text-labelclr font-semibold text-sm tracking-wider">
                      Role
                    </label>
                    <span className="text-xs md:text-sm text-hlred ml-1">
                      *
                    </span>
                    <p>
                      {user?.userRole === "PORTAL_ADMIN" ? (
                        <span className="hover:bg-header_bg hover:text-red-400 px-5 py-2 rounded-md">
                          <input
                            name="userRole"
                            type="radio"
                            value="PORTAL_ADMIN"
                            className="mx-2"
                            onClick={(e) => {
                              changeUserRole(e.target.value);
                            }}
                            ref={register({
                              required: "You must specify user role",
                            })}
                          />
                          <label className="text-labelclr font-semibold text-sm tracking-wider">
                            PORTAL ADMIN
                          </label>
                        </span>
                      ) : (
                        ""
                      )}
                      <span className="hover:bg-header_bg px-5 py-2 rounded-md">
                        <input
                          name="userRole"
                          type="radio"
                          value="FACILITY_ADMIN"
                          className="mx-2"
                          onClick={(e) => {
                            changeUserRole(e.target.value);
                          }}
                          ref={register({
                            required: "You must specify user role",
                          })}
                        />
                        <label className="text-labelclr font-semibold text-sm tracking-wider">
                          FACILITY ADMIN
                        </label>
                      </span>
                      <span className="hover:bg-header_bg px-5 py-2 rounded-md">
                        <input
                          name="userRole"
                          type="radio"
                          value="FACILITY_USER"
                          className="mx-2"
                          onClick={(e) => {
                            changeUserRole(e.target.value);
                          }}
                          ref={register({
                            required: "You must specify user role",
                          })}
                        />
                        <label className="text-labelclr font-semibold text-sm tracking-wider">
                          FACILITY USER
                        </label>
                      </span>
                      <span className="hover:bg-header_bg px-5 py-2 rounded-md">
                        <input
                          name="userRole"
                          type="radio"
                          value="EMAR_USER"
                          className="mx-2"
                          onClick={(e) => {
                            changeUserRole(e.target.value);
                          }}
                          ref={register({
                            required: "You must specify user role",
                          })}
                        />
                        <label className="text-labelclr font-semibold text-sm tracking-wider">
                          EMAR USER
                        </label>
                      </span>
                      <span className="hover:bg-header_bg px-5 py-2 rounded-md">
                        <input
                          name="userRole"
                          type="radio"
                          value="PROVIDER"
                          className="mx-2"
                          onClick={(e) => {
                            changeUserRole(e.target.value);
                          }}
                          ref={register({
                            required: "You must specify user role",
                          })}
                        />
                        <label className="text-labelclr font-semibold text-sm tracking-wider">
                          PROVIDER
                        </label>
                      </span>
                    </p>
                  </li>
                )}
              </>
              {errors.userRole && userType === "EXTERNAL" && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  {errors.userRole?.message}
                </p>
              )}

              <>
                {user?.userId === userdetails?.userId ? (
                  ""
                ) : (
                  <li
                    className={`inline-block text-xs leading-6 text-menu_txt w-full mb-3 ${
                      userType === "INTERNAL" ? "show" : "hidden"
                    }`}
                  >
                    <label className="text-labelclr font-semibold text-sm tracking-wider">
                      Role
                    </label>
                    <span className="text-xs md:text-sm text-hlred ml-1">
                      *
                    </span>
                    <p>
                      <span className="hover:bg-header_bg px-5 py-2 rounded-md">
                        <input
                          name="userRole"
                          type="radio"
                          value="DEPARTMENT_ADMIN"
                          onClick={(e) => {
                            changeUserRole(e.target.value);
                          }}
                          ref={register({
                            required: "You must specify user role",
                          })}
                          className="mx-2"
                        />
                        <label className="text-labelclr font-semibold text-sm tracking-wider">
                          DEPARTMENT ADMIN
                        </label>
                      </span>
                      <span className="hover:bg-header_bg px-5 py-2 rounded-md">
                        <input
                          name="userRole"
                          type="radio"
                          value="DEPARTMENT_USER"
                          className="mx-2"
                          onClick={(e) => {
                            changeUserRole(e.target.value);
                          }}
                          ref={register({
                            required: "You must specify user role",
                          })}
                        />
                        <label className="text-labelclr font-semibold text-sm tracking-wider">
                          DEPARTMENT USER
                        </label>
                      </span>
                    </p>
                  </li>
                )}
              </>
              {userType === "INTERNAL" && errors.userRole && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  {errors.userRole?.message}
                </p>
              )}
              {userType === "INTERNAL" &&
              user?.userId !== userdetails?.userId ? (
                <li
                  className={`inline-block text-xs leading-6 text-menu_txt w-full mb-3`}
                >
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Department
                  </label>
                  <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                  <select
                    name="department"
                    aria-label="Select Department"
                    defaultValue={deptSelected}
                    disabled={facilityDisable}
                    ref={register({
                      required: "You must select department",
                    })}
                    onChange={(e) => {
                      handleChangeDept(e.target.value);
                    }}
                    className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                  >
                    <option value="">Select Department</option>
                    <option value="ORDER_ENTRY">Order Entry</option>
                    <option value="MARKETING">Marketing</option>
                    <option value="ACCOUNTING">Accounting</option>
                    <option value="FULFILLMENT">Fulfillment</option>
                    <option value="CLINICAL">Clinical</option>
                    <option value="INVENTORY">Inventory</option>
                  </select>
                </li>
              ) : (
                ""
              )}
              {errors.department && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  {errors.department?.message}
                </p>
              )}
              {(userRole === "FACILITY_ADMIN" ||
                userRole === "FACILITY_USER" || userRole === "EMAR_USER" || userRole === "PROVIDER") &&
              userType === "EXTERNAL" &&
              user?.userId !== userdetails?.userId ? (
                <>
                  <li
                    className={`inline-block text-xs leading-6 text-menu_txt w-full mb-3 createUserMultisel ${
                      userType === "EXTERNAL" ? "show" : "hidden"
                    }`}
                  >
                    <label className="text-labelclr font-semibold text-sm tracking-wider">
                      Facility
                    </label>
                    <span className="text-xs md:text-sm text-hlred ml-1">
                      *
                    </span>
                    <>
                      {facilityList ? (
                        <Multiselect
                          name="facList"
                          displayValue="name"
                          selectedValues={facilitySelected}
                          options={facilityList}
                          ref={multiselectRef}
                          onSelect={(e) => {
                            facSelect(true);
                          }}
                          onRemove={(e) => {
                            facSelect(false);
                          }}
                        />
                      ) : (
                        ""
                      )}
                    </>
                  </li>
                  <ul className="border">
                    <li className="text-center bg-menu_active py-2 font-extrabold">
                      Accounting/Billing
                    </li>
                    <li
                      className={`inline-block text-sm leading-8 w-full externalRole mb-3 px-2 ${
                        userType === "EXTERNAL" ? "show" : "hidden"
                      }`}
                    >
                      <label className="text-labelclr font-semibold text-sm tracking-wider">
                        Payor
                      </label>
                      <>
                        {parentsList ? (
                          <Multiselect
                            name="parentList"
                            isObject={false}
                            selectedValues={payorListSelected}
                            options={parentsList}
                            ref={multiselectRef1}
                            onSelect={(e) => {
                              payorSelect(true);
                            }}
                            onRemove={(e) => {
                              payorSelect(false);
                            }}
                          />
                        ) : (
                          ""
                        )}
                      </>
                    </li>
                    <li
                      className={`inline-block text-sm leading-8 w-full externalRole mb-3 px-2 ${
                        userType === "EXTERNAL" ? "show" : "hidden"
                      }`}
                    >
                      <label className="text-labelclr font-semibold text-sm tracking-wider">
                        Group Codes
                      </label>
                      <>
                        {groupCodeList ? (
                          <Multiselect
                            name="grpList"
                            displayValue="group"
                            selectedValues={grpListSelected}
                            options={groupCodeList}
                            ref={multiselectRef2}
                            onSelect={(e) => {
                              grpsSelect(true);
                            }}
                            onRemove={(e) => {
                              grpsSelect(false);
                            }}
                          />
                        ) : (
                          ""
                        )}
                      </>
                    </li>
                  </ul>
                </>
              ) : (
                ""
              )}

              <li>
                <input
                  className="hidden"
                  id="fid"
                  name="fid"
                  ref={register({ required: false })}
                />
                <input
                  className="hidden"
                  id="deptid"
                  name="deptid"
                  ref={register({ required: false })}
                />
                <input
                  className="hidden"
                  id="uType"
                  name="uType"
                  ref={register({ required: false })}
                />
                <input
                  className="hidden"
                  id="uRole"
                  name="uRole"
                  ref={register({ required: false })}
                />
              </li>
              <li className="inline-block text-sm leading-8 w-full">
                <button
                  type="submit"
                  className="rounded font-medium h-10 text-white w-full bg-login_btn my-3 focus:outline-none text-sm"
                  aria-label="Create user"
                >
                  SUBMIT
                </button>
              </li>
            </ul>
          </form>
          <Modal open={chgepwdOpen} onClose={onClosePwdModal}>
            <div>
              <h3
                className="text-lg leading-6 font-medium text-gray-900 text-center"
                id="modal-headline"
              >
                Change Password
              </h3>
              <div>
                <form onSubmit={handleSubmit(changePwdSubmit)}>
                  <ul className="p-2">
                    <li className="relative pt-4 sm:md-0">
                      <p className="text-menu_txt text-xs mb-1">
                        <li
                          className={`inline-block text-xs leading-6 text-menu_txt w-full mb-3`}
                        >
                          <label className="text-labelclr font-semibold text-sm tracking-wider">
                            Current Password
                          </label>
                          <span className="text-xs md:text-sm text-hlred ml-1">
                            *
                          </span>
                        </li>
                        <input
                          type="text"
                          id="currentPaswd"
                          name="currentPaswd"
                          placeholder="Current Password"
                          ref={register({
                            required: "You must specify Current Password",
                          })}
                          className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                        />
                        {errors.currentPaswd && (
                          <p className="text-xs md:text-sm md:pt-1 text-hlred">
                            {errors.currentPaswd?.message}
                          </p>
                        )}
                      </p>
                    </li>
                    <li className="relative">
                      <p className="text-menu_txt text-xs mb-1">
                        <li
                          className={`inline-block text-xs leading-6 text-menu_txt w-full mb-3`}
                        >
                          <label className="text-labelclr font-semibold text-sm tracking-wider">
                            New Password
                          </label>
                          <span className="text-xs md:text-sm text-hlred ml-1">
                            *
                          </span>
                        </li>
                        <input
                          type="text"
                          id="newPaswd"
                          name="newPaswd"
                          placeholder="New Password"
                          ref={register({
                            required: "You must specify New Password",
                            pattern: {
                              value:
                                /^(?=.*[0-9])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{8,}$/i,
                              message:
                                "Password should be atleast 8 character long,one upper case letter,one number at the minimum",
                            },
                          })}
                          className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                        />
                        {errors.newPaswd && (
                          <p className="text-xs md:text-sm md:pt-1 w-72 text-hlred">
                            {errors.newPaswd?.message}
                          </p>
                        )}
                      </p>
                    </li>
                    <li>
                      <button
                        type="submit"
                        className="text-white w-full h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-semibold capitalize"
                      >
                        SUBMIT
                      </button>
                    </li>
                  </ul>
                </form>
              </div>
              {/*
               */}
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(CreateUser)
);
